import * as universal from "../../../../src/routes/(app)/settings/+page.ts";
export { universal };
export { default as component } from "../../../../src/routes/(app)/settings/+page.svelte";